import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils/cn';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'panel' | 'inset' | 'plain';
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'panel', className, children, ...props }, ref) => {
    const variants = {
      panel: 'bg-vellum border border-rule rounded-chart',
      inset: 'bg-wash border border-rule rounded-chart',
      plain: 'bg-transparent',
    };

    return (
      <div
        ref={ref}
        className={cn('p-6', variants[variant], className)}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export { Card };
